import React from 'react';
import ReactDOM from 'react-dom';
import './main.css';
import App from './app/App';

ReactDOM.render(<App />, document.getElementById('root'));
